import React from 'react'
import { useScrollReveal } from '../hooks/useScrollReveal'

const AboutSection: React.FC = () => {
  const { ref, visible } = useScrollReveal<HTMLElement>()

  return (
    <section id="about" ref={ref} className={`v2-about v2-reveal ${visible ? 'is-visible' : ''}`}>
      <h2 className="v2-about__title">You could meet anywhere.</h2>
      <p className="v2-about__body">At your regular coffee spot. After a workout. Across the room from your friends. Ivy helps you meet people at the places you already go.</p>
    </section>
  )
}

export default AboutSection
